import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { RootState } from '@/components/WellLoggingOperations/types';

/**
 * init gdi only if column visible
 */
export const useGdi = (wellId: string, wellKey: string) => {
    const tabletSettings = useSelector((state: RootState) => state.tabletSettings[wellKey]);

    const { init, resetResearchVisibilityById } = useDispatch<any>().gdiWell;

    useEffect(() => {
        if (tabletSettings?.columnsVisibility.fluidTest) {
            init(wellId);
        }

        return () => {
            resetResearchVisibilityById(wellId);
        };
    }, [init, resetResearchVisibilityById, tabletSettings?.columnsVisibility.fluidTest, wellId]);
};
